export * from '../src/composites/wui-input-text/index.js';
//# sourceMappingURL=wui-input-text.js.map